export default "__VITE_ASSET__2b23c974__"